// @flow

import type {IntegrationCheckersDataIntegrationCheckerResult} from '../../generatedTypes';

const initialIntegrationCheckersData: IntegrationCheckersDataIntegrationCheckerResult = {
  type: 'accept_a_payment',
  results: [
    {
      type: 'accept_a_payment_payment_succeeds_inline',
      success: null,
      target_object_created: null,
      target_object_id: null,
      checks: [
        {
          name: 'creates_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'creates_card_with_elements',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'confirms_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
      ],
    },
    {
      type: 'accept_a_payment_payment_succeeds',
      success: null,
      target_object_created: null,
      target_object_id: null,
      checks: [
        {
          name: 'creates_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'creates_card_with_elements',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'confirms_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
      ],
    },
    {
      type: 'accept_a_payment_payment_requires_action',
      success: null,
      target_object_created: null,
      target_object_id: null,
      checks: [
        {
          name: 'creates_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'creates_card_with_elements',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'confirms_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'authenticated_the_payment',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
      ],
    },
    {
      type: 'accept_a_payment_payment_fails_insufficient_funds',
      success: null,
      target_object_created: null,
      target_object_id: null,
      checks: [
        {
          name: 'creates_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'creates_card_with_elements',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'confirms_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'fails_with_insufficient_funds',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
      ],
    },
    {
      type: 'sepa_debit_accept_a_payment_payment_succeeds',
      success: null,
      target_object_created: null,
      target_object_id: null,
      checks: [
        {
          name: 'creates_payment_intent_saved_to_customer',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'creates_payment_method_and_mandate_with_elements',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'confirms_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'handles_payment_intent_success',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
      ],
    },
    {
      type: 'sepa_debit_accept_a_payment_payment_fails',
      success: null,
      target_object_created: null,
      target_object_id: null,
      checks: [
        {
          name: 'creates_payment_intent_saved_to_customer',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'creates_payment_method_and_mandate_with_elements',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'confirms_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'handles_payment_intent_failure',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
      ],
    },
    {
      type: 'sepa_debit_accept_a_payment_payment_disputed',
      success: null,
      target_object_created: null,
      target_object_id: null,
      checks: [
        {
          name: 'creates_payment_intent_saved_to_customer',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'creates_payment_method_and_mandate_with_elements',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'confirms_payment_intent',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'handles_payment_intent_success',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
        {
          name: 'dispute_created_webhook',
          event: null,
          log: null,
          success: null,
          errors: [],
        },
      ],
    },
  ],
};

export {initialIntegrationCheckersData};
